import { Snackbar, Alert } from '@mui/material';
import PropTypes from 'prop-types';

const Notification = ({ notification, hideNotification }) => {
	// Avoid rendering an empty Snackbar after the notification has been dismissed
	if (!notification) return null;

	return (
		<Snackbar
			open
			autoHideDuration={notification.duration || 6000}
			onClose={hideNotification}
		>
			<Alert
				onClose={hideNotification}
				severity={notification.severity}
				sx={{ width: '100%' }}
			>
				{notification.message}
			</Alert>
		</Snackbar>
	);
};

Notification.propTypes = {
	notification: PropTypes.shape({
		message: PropTypes.string.isRequired,
		severity: PropTypes.oneOf(['error', 'warning', 'info', 'success']),
		duration: PropTypes.number,
	}),
	hideNotification: PropTypes.func.isRequired,
};

export default Notification;
